export const patternManifesto = () => {
  const manifesto = document.querySelector('.pattern-manifesto');
  if (manifesto) {
    const container = manifesto.firstElementChild;
    const innerBlocks = container.querySelectorAll(
      '.wp-block-heading, .wp-block-paragraph'
    );
    const title = innerBlocks[0];

    let titleHeight = 0;
    let itemHeight = 0;

    if (innerBlocks.length > 0) {
      console.log('heading');
      for (const block of innerBlocks) {
        // add block wrappers
        const type = block.tagName === 'P' ? 'item' : 'title';
        $(block).wrap(`<div class="pattern-manifesto__sticky-${type}">`);

        // calculate tallest paragraph
        const bounds = block.getBoundingClientRect();
        const { height } = bounds;

        if ($(block).hasClass('wp-block-heading')) {
          titleHeight = height;
        } else if (height > itemHeight) itemHeight = height;
      }
    }

    let triggerHeight = window.innerHeight / 2 - itemHeight / 2;

    $('.pattern-manifesto__sticky-title').css({
      '--height': `${titleHeight}px`,
      '--top': `${triggerHeight - titleHeight}px`,
    });
    $('.pattern-manifesto__sticky-item').css({
      '--height': `${itemHeight}px`,
      '--top': `${triggerHeight}px`,
    });

    const styles = window.getComputedStyle(
      document.querySelector('.pattern-manifesto__sticky-item')
    );
    const gap = parseInt(styles.marginBottom);

    // on window scroll
    window.addEventListener('scroll', () => {
      for (const [i, block] of innerBlocks.entries()) {
        // get bounds of wrapping div instead, paragraphs will get fixed position
        const bounds = block.parentElement.getBoundingClientRect();
        const { top, height } = bounds;

        const isSticky = $(block).hasClass('wp-block-heading')
          ? top <= triggerHeight - height
          : top <= triggerHeight;

        // if is middle of screen, make sticky // NOTE: offset by top video height later
        if (isSticky && !block.hasAttribute('sticky')) {
          block.setAttribute('sticky', '');
        } else if (!isSticky) {
          block.removeAttribute('sticky');
        }

        if (i > 0 && top <= window.innerHeight) {
          if (!isSticky) {
            // fade in from bottom
            // get start & end positions to use as opacity percentage
            const endHeight =
              window.innerHeight - (triggerHeight + itemHeight) + gap;
            const startHeight = window.innerHeight - top;

            // add some easing to opacity
            let opacity = startHeight / endHeight;
            opacity = opacity * opacity * opacity;
            block.style.opacity = opacity > 1 ? 1 : opacity;
            //
          } else if (/* not title slide */ i + 1 < innerBlocks.length) {
            // fade out when next slide reaches bottom
            // start fading out when half of the next gap has been scrolled
            const startHeight =
              window.innerHeight - (triggerHeight + itemHeight) - gap / 2;

            let opacity = top / startHeight;

            if (opacity < 0) {
              block.style.opacity = 0;
              block.style.pointerEvents = 'none';
            } else {
              block.style.opacity = opacity > 1 ? 1 : opacity;
              block.style.pointerEvents = null;
            }
          }
        }

        if (i + 1 === innerBlocks.length) {
          // end of slides, desticky stuff
          if (block.hasAttribute('sticky')) {
            if (!title.style.top) {
              const {
                width: titleWidth,
                height: titleHeight,
                top: titleTop,
              } = title.getBoundingClientRect();
              const { height: parentHeight, top: parentTop } =
                title.parentElement.parentElement.parentElement.getBoundingClientRect();

              const isMobile = !window.matchMedia('(min-width: 768px)').matches;
              const padding = 88;
              const distanceFromBottom = titleWidth < 592 ? titleWidth : 592;
              const positionTop =
                parentHeight - // parent container height
                distanceFromBottom - // height of background circle
                (isMobile ? titleHeight : 0) - // on mobile subtract title container height
                padding; // 88 px bot padding.

              title.style.top = `${positionTop}px`;
              title.style.position = `absolute`;
            }
          } else {
            title.style.top = null;
            title.style.position = null;
          }
        }
      }
    });
  }
};
